import { FC } from "react";
import { TabType } from "../types/rentalCarDatesRangeInput.types";
import { useData } from "data/data-provider";

const TabSwitcher = () => {
  const { activeTab, setActiveTab, selectedCar } = useData();  return (
    <div className="flex justify-center mb-6">
      <div className="inline-flex bg-[#F2F4F7] rounded-full p-1">
        {(["dates", "weeks", "months"] as TabType[]).map((tab) => (
          <button
            key={tab}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab(tab);
            }}
            className={`px-6 py-2 rounded-full text-sm font-medium transition-all capitalize ${
              activeTab === tab
                ? "bg-primary-200 hover:bg-primary-700 text-button-color shadow-sm"
                : "text-[#667085] hover:text-[#344054]"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabSwitcher;
